import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/functions";

export default class AuthModel {
  public static async logIn(phone: string, password: string) {
    const token = await this.getLoginToken(phone, password);
    return firebase.auth().signInWithCustomToken(token);
  }

  private static async getLoginToken(
    phone: string,
    password: string
  ): Promise<string> {
    const logIn = firebase.functions().httpsCallable("logIn");
    const response = await logIn({ phone, password });
    const { success, message } = response.data;

    if (!success) {
      throw response.data;
    }
    return message;
  }

  public static async logOut() {
    return firebase.auth().signOut();
  }

  public static getFirebaseAuth() {
    return firebase.auth();
  }

  public static async register(phone: string, password: string) {
    const register = firebase.functions().httpsCallable("signUp");
    const response = await register({ phone, password });
    const { success, message } = response.data;

    if (!success) {
      throw new Error(message);
    }

    const token = message;

    return firebase.auth().signInWithCustomToken(token);
  }
}
